import { createActionCreator } from '../utils/helpers';

import { postcoderAddress, postcoderResetSearch, postcoderSearch } from './types';

export const requestPostcoderAddress = createActionCreator(
  postcoderAddress.request,
  'term',
  'id',
  'promise',
);
export const requestPostcoderAddressSuccess = createActionCreator(
  postcoderAddress.success,
  'response',
);
export const requestPostcoderAddressFailure = createActionCreator(
  postcoderAddress.failure,
  'error',
);

export const requestPostcoderSearch = createActionCreator(
  postcoderSearch.request,
  'term',
  'filter',
);
export const requestPostcoderSearchSuccess = createActionCreator(
  postcoderSearch.success,
  'response',
);
export const requestPostcoderSearchFailure = createActionCreator(postcoderSearch.failure, 'error');

export const resetPostcoderSearch = createActionCreator(postcoderResetSearch);
